export default __webpack_public_path__ + "static/mobilepush-95e8ed17843662aacff97523f17f3f48.png";